<template>
<div class="xueWeiIndex bg-grey">
  <div class="content-width">
    <el-row :gutter="24">
      <el-col :span="18">
        <div class="box">
          <div @click="jingluo()" class="box-img">
            <img src="../assets/img/jl.png"/>
            <p>经络</p>
          </div>
          <div  @click="xuewei()" class="box-img">
            <img src="../assets/img/xw.png"/>
            <p>穴位</p>
          </div>
        </div>
      </el-col>
      <!-- 右边收藏列表 -->
      <el-col :span="6">
        <el-row style="margin-bottom: 10px">
          <el-col>
            <div class="right-list">
              <div class="collection-title">
                <img src="../assets/img/book.png" alt /> 腧穴的定位
              </div>
              <div class="list-one">
                <div
                  @click="shuxueD(item.id)"
                  v-for="(item, index) in shuXueList"
                  :key="index"
                >
                  {{ limitMaxWords(12, item.name) }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" class="adv-wrap">
            <div
              class="common-img-outer setPositon listdetail-adver-outer-img"
              v-for="(item, index) in jingxueAdverList"
              :key="index"
            >
              <a :href="item.urlLink">
                <img :src="$store.state.imgUrl+item.urlImage" alt style="width: 100%" />
                <span class="adver-words-tip" v-if="item.urlImage">{{
                    adverWordsTip
                  }}</span>
              </a>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
export default {
name: "jinluoandxuewei",
  data() {
    return {
      showS: false, //搜索框不显示
      searchInput: '',
      all: true,
      dataList: [],
      shuXueList: [],
      jingxueAdverList: []
    }
  },
  mounted() {
    this.getShuxueList()
    this.getPositionAdver()
  },
  methods: {
    //获取腧穴列表
    getShuxueList() {
      let that = this;
      let url = "/jlxw/sxdwf/list";
      that.$http
        .post(url)
        .then(res => {
          if (res.data.code == 200) {
            that.shuXueList = res.data.data
          } else {
            that.$message.error(res.message);
          }
        })
    },
    // 获取广告
    getPositionAdver() {
      let that = this;
      let url = "/news/getByAdvseat";
      let params = {
        advSeat: 5,
        seatId: 3,
      }
      that.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          let arr = res.data.data;
          //经络穴位
          that.jingxueAdverList = arr.map(
            (item, index) => {
              return {
                urlImage: item.urlImage,
                urlLink: item.urlLink,
              };
            }
          );
        } else {
          that.$message.error(res.message);
        }
      })
    },

    jingluo() {
      this.visible3 = false;
      this.$router.push({
        path: "/JingLuoIndex",
      });
    },
    xuewei() {
      this.visible3 = false;
      this.$router.push({
        path: "/xueWeiIndex",
      });
    },
    //腧穴详情
    shuxueD(id) {
      this.$router.push({
        path: "/shuxueDetail",
        query: { id: id },
      });
    },
    //搜索按钮
    searchB() {
      let that = this;
      if (that.showS) {
        that.showS = false;
      } else {
        that.showS = true;
      }
    },
    keyWords(searchInput) {
      let that = this;
      that.pageInfo1.pageNum = 1;
      that.getList(searchInput);
      that.all = false;
    },
    //全部
    allData() {
      let that = this;
      that.searchInput = "";
      that.all = true;
      that.pageInfo1.pageNum = 1;
      that.getList();
    },
    jingluoD() {

    },
    getList(val) {
      let that = this;
      let parmas = {
        pageNum: 1,
        pageSize: 2,
        name: val
      };
      let url = "/jlxw/meridians/getjlxwInfo";
      that.$http
        .post(url, parmas)
        .then((res) => {
          if (res.data.code == 200) {
            if(res.data.data.jlList || res.data.data.xwList) {
              this.dataList = res.data.data.jlList.list.concat(res.data.data.xwList)
            }
          } else {
            that.$message(res.data.msg);
          }
        })
    }
  }
}
</script>

<style scoped>
.list-one {
  height: 232px;
  overflow: auto;
}
.box {
  display: flex;
  justify-content: space-between
}
.box-img {
  width: 370px;
}
.box-img img{
  width: 100%;
}
.box-img p{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/jinluoandxuewei.vue